import * as types from './actionsTypes';

export type SaveLulavActionType = {
  type: string;
  kind: string;
  price: string | number;
  headers: any;
  onSuccess?: () => void;
};

export const saveLulavAction = (
  kind: string,
  price: string | number,
  headers: any,
  onSuccess?: () => void
): SaveLulavActionType => ({
  type: types.SAVE_NEW_LULAV,
  kind,
  price,
  headers,
  onSuccess,
});
